export { default as jobs } from './jobs';
export type { IJob } from './jobs';
export { default as projects } from './projects';
export type { IProject } from './projects';
export { default as skills}  from './skills';
export type { ISkill } from './skills';

export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
